import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Grid3x3,
  Radio,
  Cable,
  Activity,
  Settings as SettingsIcon,
  LogOut,
} from 'lucide-react';
import { logout } from '../LoginGate.js';
import { BrandLogo } from '../BrandLogo.js';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', Icon: LayoutDashboard },
  { to: '/panels', label: 'Ports verwalten', Icon: Grid3x3 },
  { to: '/partylines', label: 'Port-Gruppen', Icon: Radio },
  { to: '/externals', label: 'Externe Quellen', Icon: Cable },
  { to: '/monitor', label: 'Server-Monitor', Icon: Activity },
  { to: '/settings', label: 'Einstellungen', Icon: SettingsIcon },
] as const;

export function Sidebar(): JSX.Element {
  return (
    <aside className="w-[240px] shrink-0 border-r border-border bg-surface flex flex-col">
      <div className="h-14 px-5 flex items-center gap-3 border-b border-border">
        <BrandLogo size="md" />
        <div className="text-xxs text-text-mute uppercase tracking-widest">
          Intercom
        </div>
      </div>

      <nav className="flex-1 px-2 py-3 flex flex-col gap-0.5">
        {NAV.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              [
                'flex items-center gap-3 px-3 py-2 rounded-btn text-sm transition',
                isActive
                  ? 'bg-elev text-text'
                  : 'text-text-dim hover:bg-elev hover:text-text',
              ].join(' ')
            }
          >
            <Icon size={16} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-2 py-2 border-t border-border">
        <button
          type="button"
          onClick={logout}
          className="w-full flex items-center gap-3 px-3 py-2 rounded-btn text-sm text-text-dim hover:bg-elev hover:text-text transition"
        >
          <LogOut size={16} />
          <span>Abmelden</span>
        </button>
      </div>

      <div className="px-4 py-3 border-t border-border text-xxs text-text-mute">
        v0.1.0 · self-hosted
      </div>
    </aside>
  );
}
